import { ThemeUICSSObject } from '@apia/theme';
import digitalSign from './digitalSign';
import environmentsSelector from './environmentsSelector';
import categoriesTree from './categoriesTree';
import uploader from './uploader';
import stepper from './stepper';
/* IMPORT HERE */

const components: ThemeUICSSObject = {
  digitalSign,
  environmentsSelector,
  categoriesTree,
  uploader,
  stepper,
  /* PREPEND HERE */
};

export default components;
